<template>
    <div class="field-control">
        <select v-model="selectedChassis" multiple v-if="isMobile">
            <option value="" disabled>SELECT CHASSIS</option>
            <option v-for="chassis in getChassis" :value="chassis.KUZOV">{{ chassis.KUZOV }}({{ chassis.TAG2 }})</option>
        </select>
    <div class="advance-dropdowns">
        <div class="field is-horizontal" v-if="false">
            <div class="field-label is-normal">
                <label class="label">Select Chassis</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <div class="control">
                        <div class="select is-fullwidth">
                            <select v-model="selectedChassis" multiple>
                                <option v-for="chassis in getChassis" :value="chassis.KUZOV">{{ chassis.KUZOV }}({{ chassis.TAG2 }})</option>
                            </select>
                            <div class="advance-dropdown"><i class="fa fa-angle-down"></i></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="auction-drop-box" v-if="!isMobile">
            <div class="car-select-tabs" :class="[(!isMobile ? 'hide' : '')]" @click="expandSelect">{{ chassis.length ?
                chassis.map(c => { return c.KUZOV + '(' + c.TAG2 + ')' }).join(',') : 'Select CHASSIS' }}
            </div>

            <div class="car-select-box box"
                 :class="[(isMobile ? 'is-wider' : ''), (isMobile && !expand ? 'hide' : '')]">
                <table class="table" v-if="isModelSelected">
                    <tr>
                        <td class="is-category">SELECT CHASSIS</td>
                    </tr>
                    <tr v-for="chassis in getChassis">
                        <td :class="{ 'is-primary' : isSelected(chassis) }" @click="selectChassis(chassis)"><span
                                v-html="chassis.KUZOV"></span>({{ chassis.TAG2 }})
                        </td>
                    </tr>
                </table>
                <p v-else="">Select Model...</p>
            </div>
        </div>
    </div>
    </div>
</template>

<script>
    export default {
        computed: {

            selectedChassis: {
                get: function () {
                    return this.$store.getters.getQueryChassis;
                },
                set: function (chassis) {
                    this.$store.dispatch('setChassisQuery', chassis);

                }
            },
            getChassis() {
                this.chassis = [];
                return this.$store.getters.getAllChassis
            },
            isModelSelected() {
                return this.$store.getters.getQueryModels.length > 0
            },
            isMobile() {
                return document.documentElement.clientWidth < 450
            }
        },
        data() {
            return {
                expand: false,
                chassis: []
            }
        },
        methods: {
            isSelected(chassis) {
                return this.$store.getters.getQueryChassisByChassis(chassis.KUZOV).length !== 0
            },
            selectChassis(chassis) {
                if (this.$store.getters.getQueryChassisByChassis(chassis.KUZOV).length === 0) {
                    this.chassis.push(chassis);
                    this.$store.dispatch('handleQueryChassis', chassis.KUZOV)
                } else {
                    while (this.chassis.indexOf(chassis) !== -1) {
                        this.chassis.splice(this.chassis.indexOf(chassis), 1)
                    }
                    this.$store.dispatch('removeChassisFromQuery', chassis.KUZOV)
                }
            },
            expandSelect() {
                this.expand = !this.expand;
            },
        }
    }
</script>

<style scoped>
    .box {
        height: 250px;
        width: 180px;
        overflow-y: auto;
    }

    .is-category {
        background-color: whitesmoke;
        font-weight: bold;
        color: #73aa00;
    }

    td {
        white-space: nowrap !important;
        overflow: hidden !important;
        text-overflow: ellipsis !important;
        font-size: 14px !important;
        height: 15px !important;
        padding: 0px !important;
        font-weight: bold !important;
    }

    .is-wider {
        width: 100% !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/Auctions/Advance/Inputs/Chassis.vue